import { memo } from 'react'
import { useDndContext, useDroppable } from '@dnd-kit/core'

import { getGapAfterId } from './utils'
import * as Styled from './styled'

export interface IBetweenLinesGapProps {
  afterLineIndex: number
  className?: string
  externalIsDragActive: boolean
  externalIsOver: boolean
}

const BetweenLinesGap = ({
  afterLineIndex,
  className,
  externalIsDragActive,
  externalIsOver
}: IBetweenLinesGapProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id: getGapAfterId(afterLineIndex)
  })
  const { active } = useDndContext()

  return (
    <Styled.BetweenLinesGap
      ref={setNodeRef}
      className={className}
      $isOver={isOver || externalIsOver}
      $isDragging={Boolean(active) || externalIsDragActive}
      data-gap-after-line-index={afterLineIndex}
    />
  )
}

export default memo(BetweenLinesGap)
